import React from 'react'
import { Nav } from './Nav'

export const BasePage = ({ Comp }) => {
  return (
    <div className="ml-5 my-5">
      <div className="d-flex justify-space-between">
        <div className="minw-50">
          <Nav />
        </div>
      </div>
      <div className="">
        <Comp />
      </div>
    </div>
  )
}
